module.exports = __webpack_public_path__ + "img/download.cd8d74ce.svg";